module.exports = {
          srcSet: __webpack_public_path__ + "74731ebd702d56ed99dff5fa0fe5f0af-128.png"+" 128w",
          images:[ {path: __webpack_public_path__ + "74731ebd702d56ed99dff5fa0fe5f0af-128.png",width: 128,height: 128}],
          src: __webpack_public_path__ + "74731ebd702d56ed99dff5fa0fe5f0af-128.png",
          toString:function(){return __webpack_public_path__ + "74731ebd702d56ed99dff5fa0fe5f0af-128.png"},
          
          width: 128,
          height: 128
        }